<template>
	<ul class="srh__department-toggle flex h-[3.5714285rem] font-medium text-gray-70">
		<ToggleItem v-for="[key, label] in departmentsMap" :key="key" :department-type="key">{{ label }}</ToggleItem>
	</ul>
</template>

<script lang="ts" setup>
import { useI18n } from "vue-i18n";
import ToggleItem from "./ToggleItem.vue";
import { country } from "@ocm/services/ocm-object";
import type { Department } from "@ocm/global-types";

const { t } = useI18n();

const departmentsMap = new Map<Department, string>(
	country === "int"
		? [
				["women", t("siteWide.searchApp.department.women")],
				["men", t("siteWide.searchApp.department.men")],
		  ]
		: [
				["damen", t("siteWide.searchApp.department.women")],
				["herren", t("siteWide.searchApp.department.men")],
				["kinder", t("siteWide.searchApp.department.kids")],
		  ]
);
</script>

<style>
.srh__department-toggle {
	box-shadow: inset 0 -2px 0 0 var(--color-gray-40);
}
</style>
